<template>
    <div>
        <div
            v-show="showPop"
            :style="{left: popX + 'PX', top: popY + 'PX'}"
            class="stage-pop"
            @mouseenter="handleEnterPop"
            @mouseleave="handleMouseLeave"
        >
            <div
                v-if="leftStageList.length"
                class="stage-pop-left"
            >
                <div
                    v-for="(item, index) in leftStageList"
                    :key="index"
                    class="stage-pop-item clearfix"
                >
                    <div class="item-title">
                        {{ item.title }}
                    </div>
                    <ul
                        class="item-desc"
                    >
                        <li
                            v-for="(t, idx) in item.content"
                            :key="idx"
                        >
                            {{ t }}
                        </li>
                    </ul>
                </div>
            </div>
            <div
                v-if="rightStageList.length"
                class="stage-pop-right"
            >
                <div
                    v-for="(item, index) in rightStageList"
                    :key="index"
                    class="stage-pop-item clearfix"
                >
                    <div class="item-title">
                        {{ item.title }}
                    </div>
                    <ul
                        class="item-desc"
                    >
                        <li
                            v-for="(t, idx) in item.content"
                            :key="idx"
                        >
                            {{ t }}
                        </li>
                    </ul>
                </div>
            </div>
            <div
                class="triangle"
                :style="{left: `${triangleX}px`}"
            />
        </div>
        <div
            v-if="isShowClose"
            class="close"
            @click="closeModal"
        />
    </div>
</template>

<script>
    let popTimer = null;
    export default {
        props: {
            stageList: {
                type: Array,
                default() {
                    return [];
                }
            },
            // 阻止鼠标移出事件
            isPreventMouseLeave: {
                default: false,
                type: Boolean,
            },
            // 是否展示关闭按钮
            isShowClose: {
                default: false,
                type: Boolean,
            },
        },
        data() {
            return {
                current: -1,
                triangleX: 0,
                popY: 0,
                popX: 0,
                showPop: false,
            };
        },
        computed: {
            leftStageList() {
                let current = this.current;
                if (current === -1) return [];
                return this.stageList[current].detail.filter((item, index) => index % 2 === 0);
            },
            rightStageList() {
                let current = this.current;
                if (current === -1) return [];
                return this.stageList[current].detail.filter((item, index) => index % 2 !== 0);
            },
        },
        methods: {
            handleEnterPop() {
                clearTimeout(popTimer);
                this.showPop = true;
            },
            handleMouseLeave() {
                if (this.isPreventMouseLeave) return;
                popTimer = setTimeout(() => {
                    this.current = -1;
                    this.showPop = false;
                }, 300);
            },
            handleMouseEnter(e, index) {
                clearTimeout(popTimer);
                this.showPop = true;
                this.current = index;
                const currentTarget = e.currentTarget;
                this.triangleX = currentTarget.offsetLeft + currentTarget.clientWidth / 2 - 14;
                this.popY = currentTarget.offsetTop + currentTarget.clientHeight + 15;
            },
            controlPop(isShow, index = -1) {
                this.showPop = isShow;
                this.current = index;
            },
            closeModal() {
                this.$emit('close');
            }
        }
    };
</script>

<style lang="less" scoped>
    .stage-pop {
        background: #fff;
        border: 1PX solid rgba(229,169,127,1);
        padding: 41PX 43PX 0PX 43PX;
        position: absolute;
        border-radius: 10PX;
        width: 1200PX;
        box-sizing: border-box;
        z-index: 5;
        .triangle {
            position: absolute;
            top: -17PX;
            width: 28PX;
            height: 18PX;
            background: url('https://s21.lgstatic.com/growth/activity/20210128/1611825528222.png') top center no-repeat;
        }

        .stage-pop-left {
            float: left;
            margin-right: 20PX;
        }

        .stage-pop-right {
            float: right;
        }

        &-item {
            width: 510PX;
            margin-bottom: 40PX;
            display: flex;
            align-items: baseline;

            .item-title {
                width: 115PX;
                float: left;
                margin-right: 42PX;
                vertical-align: top;
                font-size:20PX;
                font-family:PingFang SC;
                font-weight:500;
                color:rgba(65,55,81,1);
                line-height:24PX;
            }

            .item-desc {
                position: relative;
                float: left;
                width: 350PX;

                li {
                    position: relative;
                    font-size: 16PX;
                    line-height: 24PX;
                    margin-bottom: 12PX;
                    color: rgba(65, 55, 81, 1);
                    &:last-child {
                        margin: 0;
                    }

                    &:before {
                        content: " ";
                        width:6PX;
                        height:6PX;
                        background:rgba(65,55,81,1);
                        border-radius:50%;
                        position: absolute;
                        display: block;
                        top: 10PX;
                        left: -14PX;
                    }
                }
            }
        }
    }
    .close {
        width: 40PX;
        height: 40PX;
        position: absolute;
        right: -570PX;
        top: -270PX;
        border-radius: 50%;
        cursor: pointer;
        z-index: 10000;
        background: url("https://s21.lgstatic.com/growth/activity/20210128/1611825493855.png") no-repeat center;
        background-size: 100%;
    }
</style>